import { i18n } from '@lingui/core'
import { Trans } from '@lingui/react'

import { capitalizeFirstLetter } from 'views/utils/capitalizeFirstLetter'

import './NowContentIsEligible.scss'

interface ContentIsEligibleProps {
  deliveryDay?: string
  deliveryTime: string
  timeLeft: string
}

const NowContentIsEligible = ({
  deliveryDay,
  deliveryTime,
  timeLeft,
}: ContentIsEligibleProps) => (
  <p className={'m-NowContentIsEligible__heading'}>
    <span>
      <Trans
        id="general.label.now.collapsible.title"
        values={{
          deliveryDay: capitalizeFirstLetter(
            deliveryDay || i18n._('general.label.today')
          ),
        }}
      />
      {`, ${deliveryTime} `}
    </span>
    <Trans id={'general.label.now.collapsible.ok'} values={{ timeLeft }} />
  </p>
)

export default NowContentIsEligible
